import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import config from './social-metadata.json';

export default function SocialMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const route = pathname.replace(/\/$/, '') || '/';
    const data = config.pages[route] || config.pages['/'];
    const set = (attribute, key, value) => {
      let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, key); document.head.appendChild(element); }
      element.setAttribute('content', value);
    };
    document.title = data.title;
    set('name', 'description', data.description);
    const canonical = config.siteUrl + (config.pages[route] ? route : '/');
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
    link.href = canonical;
    for (const [key,value] of Object.entries({title:data.title, description:data.description, url:canonical, image:config.siteUrl + data.image, 'image:secure_url':config.siteUrl + data.image, 'image:alt':data.imageAlt})) set('property', 'og:' + key, value);
    for (const [key,value] of Object.entries({card:'summary_large_image', title:data.title, description:data.description, image:config.siteUrl + data.image, 'image:alt':data.imageAlt})) set('name', 'twitter:' + key, value);
  }, [pathname]);
  return null;
}
